import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { referralEmailsValidator } from "shared";
import { toast } from "sonner";
import {
  type InviteRole,
  MemberInviteField,
} from "@/components/fields/member-invite-field";
import {
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useAppForm } from "@/hooks/useCreateForm";
import { useTRPC } from "@/lib/trpcClient";

export const Route = createFileRoute("/_authed/_org/referrals/send")({
  component: RouteComponent,
});

function RouteComponent() {
  const trpc = useTRPC();
  const navigate = Route.useNavigate();
  const { queryClient } = Route.useRouteContext();

  const { mutate: sendReferrals, isPending } = useMutation(
    trpc.referral.send.mutationOptions({
      onError: (error) => {
        toast.error(error.message);
      },
      onSuccess: (response) => {
        toast.success(
          `${response.length} referral${response.length > 1 ? "s" : ""} sent`,
        );
        queryClient.invalidateQueries(trpc.referral.list.queryOptions());
        navigate({
          to: "/referrals",
        });
      },
    }),
  );

  const form = useAppForm({
    defaultValues: {
      invites: [{ email: "" } as { email: string; role?: InviteRole }],
    },
    onSubmit: ({ value }) => {
      sendReferrals(value);
    },
    validators: {
      onSubmit: referralEmailsValidator,
    },
  });

  return (
    <div className="flex h-full flex-col">
      <SheetHeader className="pb-2">
        <SheetTitle>Send Referral Invitations</SheetTitle>
        <SheetDescription>
          Refer a nonprofit leader to Givefront. When they sign up and use
          Givefront, they'll receive a $150 gift card—and you'll get one too.
        </SheetDescription>
      </SheetHeader>
      <form
        className="space-y-6 overflow-y-auto p-4"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          form.handleSubmit();
        }}
      >
        <div className="grow py-2">
          <MemberInviteField form={form} justEmails isPending={isPending} />
        </div>
      </form>
    </div>
  );
}
